export const table_translate =  {
    body: {
      emptyDataSourceMessage: 'Sem dados para exibir',
      deleteText: 'Tem de que deseja excluir esta linha?',
      emptyDataSourceMessage: 'Sem dados para exibir',
      addTooltip: 'Adicionar',
      deleteTooltip: 'Deletar',
      editTooltip: 'Editar',
      filterRow: {
        filterPlaceHolder: 'Filtrar',
        filterTooltip: 'Filtrar',
      },
      editRow: {
        deleteText: 'Tem certeza de que deseja excluir?',
        cancelTooltip: 'Cancelar',
        saveTooltip: 'Salvar',
      },
    },
    grouping: {
      placeholder: 'Arraste o título da coluna para agrupar as linhas',
      groupedBy: 'Agrupar por: ',
    },
    header: {
      actions: '',
    },
    pagination: {
      labelDisplayedRows: '{count} de {from}-{to}',
      labelRowsSelect: 'linhas',
      labelRowsPerPage: 'Linhas por página: ',
      firstAriaLabel: 'Primeira página',
      firstTooltip: 'Primeira página',
      previousAriaLabel: 'Página anterior',
      previousTooltip: 'Página anterior',
      nextAriaLabel: 'Próxima página',
      nextTooltip: 'Próxima página',
      lastAriaLabel: 'Última página',
      lastTooltip: 'Última página',
    },
    toolbar: {
      addRemoveColumns: 'Adicionar ou remover colunas',
      nRowsSelected: '{0} linha(s) selecionadas',
      showColumnsTitle: 'Mostrar colunas',
      showColumnsAriaLabel: 'Mostrar colunas',
      exportTitle: 'Exportar',
      exportAriaLabel: 'Exportar',
      exportName: 'Exportar como CSV',
      searchTooltip: 'Pesquisar',
      searchPlaceholder: 'Pesquise aqui...',
    },
  }

  export const table_style = 
  {
    headerStyle: {
        fontFamily:'Montserrat, Helvetica Neue, Arial, sans-serif',
        fontWeight:'700',
        color:'#888'
    }    
}